import React, { Component } from 'react';
import {
  combineValidators,
  composeValidators,
  isRequired,
  matchesField,
} from 'revalidate';
import qs from 'qs';
import Card from 'react-toolbox/lib/card';
import Helmet from 'react-helmet';
import CardBody from '../CardBody';

import RegistrationForm from '../RegistrationForm';
import Logo from '../Logo';
import styles from './LoginPage.scss';

import { httpGet, httpPost } from '../../http';
import LoginErrorView from '../LoginErrorView';
import LoginLoadingView from '../LoginLoadingView';

import { isValidPassword } from '../PasswordValidationStatus';

//
// const WrappedRegistrationForm = Form.create({ name: 'registration-form' })(
//   RegistrationForm
// );

export const validate = combineValidators({
  password: composeValidators(
    isRequired({
      message: 'Password is required',
    }),
    isValidPassword()
  )(),
  passwordConfirm: composeValidators(
    isRequired({
      message: 'You need to confirm your password',
    }),
    matchesField('password')({
      message: 'Passwords must match',
    })
  )(),
  firstname: isRequired('First Name'),
  username: isRequired('Email'),
  lastname: isRequired('Last Name'),
  companyName: isRequired('Company Name'),
});

const errorHandler = error => {
  if (error.status === 404) {
    if (error.message.includes('Invitation'))
      return 'Invitation was not found.';
    if (error.message.includes('Organization'))
      return 'Organization you were invited to was not found.';
  }
  if (error.status === 400) {
    if (error.message.includes('expired')) return 'Invitation has expired.';
    if (error.message.includes('Password not matching security pattern.'))
      return 'Password not matching security pattern.';
    if (error.message.includes('Email is already taken'))
      return 'Account with such email address is already taken.';
  }
  return error.message;
};

class RegistrationPage extends Component {
  constructor(props) {
    super(props);
    this.attemptLogin = this.attemptLogin.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.saveFormRef = this.saveFormRef.bind(this);
    this.state = {
      isLoading: true,
      invitation: {},
    };
  }

  componentDidMount() {
    const query = qs.parse(window.location.search.replace('?', ''));
    this.getInvitation(query.token);
  }

  getInvitation(token) {
    if (!token) {
      this.setState({
        isLoading: false,
        error: 'Invitation link is invalid.',
      });
      return;
    }

    // TODO: For the future it would be better to break these out to an API service client so we don't do "raw" http calls from the UI components.
    httpGet(`/api/userinfo/invite?token=${encodeURIComponent(token)}`)
      .then(response => {
        this.setState({
          isLoading: false,
          invitation: response,
        });
      })
      .catch(error => {
        const message = errorHandler(error);
        this.setState({
          isLoading: false,
          error: message,
        });
      });
  }

  attemptLogin() {
    this.formRef.submit();
  }

  handleSubmit(values, e) {
    this.saveFormRef(e.target);
    const isFormValid = validate(values);
    const keys = Object.keys(isFormValid);
    if (keys.length !== 0) {
      let errorString = '';
      keys.forEach(value => {
        errorString += isFormValid[value] + '\n';
      });
      this.setState({
        formError: errorString,
        isLoading: false,
      });
      return;
    }
    const body = {
      email: values.username,
      firstName: values.firstname,
      lastName: values.lastname,
      companyName: values.companyName,
      password: values.password,
    };
    httpPost(
      `/api/register?invitationId=${encodeURIComponent(
        this.state.invitation.id
      )}`,
      body
    )
      .then(() => {
        this.attemptLogin();
      })
      .catch(error => {
        const message = errorHandler(error);
        this.setState({
          isLoading: false,
          formError: message,
        });
      });
  }

  saveFormRef(formRef) {
    this.formRef = formRef;
  }

  render() {
    const { error, formError, invitation, isLoading } = this.state;

    if (error) {
      return <LoginErrorView error={error} />;
    }
    if (isLoading) return <LoginLoadingView />;
    return (
      <div key="loginWrapper" className={styles.loginWrapper}>
        <Card key="loginCard" className={styles.loginFormCard}>
          <CardBody>
            <Logo />
            <Helmet title="Registration" />
            <h1 className="text-display-1 mb-2">Register your account</h1>
            <RegistrationForm
              error={formError}
              email={invitation.email}
              onSubmit={(values, e) => this.handleSubmit(values, e)}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default RegistrationPage;



// WEBPACK FOOTER //
// ./src/client/src/components/pages/RegistrationPage.js